import 'core-js/actual/object/has-own';
// Array.prototype.at() (Chrome 92+)
import 'core-js/actual/array/at';
// Array.prototype.findLast/findLastIndex() (Chrome 97+)  
import 'core-js/actual/array/find-last';
import 'core-js/actual/array/find-last-index';

import * as Sentry from '@sentry/react';
import { RouterProvider } from '@tanstack/react-router';
import ReactDOM from 'react-dom/client';
import { getRouter } from './router';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: clientEnv.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    // sampleRate: 0.85,
  });
}

import './lib/d9-dapp-sdk';
import './index.css';
import { clientEnv } from './lib/env';

const router = getRouter();

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('app')!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement, {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  });
  root.render(<RouterProvider router={router} />);
}
